export default __webpack_public_path__ + "static/media/2140.544566a8.png";